(function () {
    'use strict';

    angular
     .module('oddCampaignModule')
     .controller('oddCampaignFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$interval', '$state', 'govNotificationDelay', 'notificationService', 'modalService', 'oddCampaignService'];

    function Controller($scope, $timeout, $interval, $state, govNotificationDelay, notificationService, modalService, oddCampaignService) {

        $scope.ctrlCtxt = {};
        // Fix dates timezone
        if ($scope.boxModel.StartDate) {
            $scope.boxModel.StartDate = moment($scope.boxModel.StartDate);
        }
        if ($scope.boxModel.DeadLine) {
            $scope.boxModel.DeadLine = moment($scope.boxModel.DeadLine);
        }

        // Add Owner Delegate
        $scope.addOwnerDelegate = function (ownerDelegate) {
            if (_.isUndefined($scope.boxModel.OwnerDelegates)) $scope.boxModel.OwnerDelegates = [];

            $scope.boxModel.OwnerDelegates.push(ownerDelegate);
        }

        // Remove Owner Delegate
        $scope.removeOwnerDelegate = function (ownerDelegate) {
            $scope.boxModel.OwnerDelegates = _.reject($scope.boxModel.OwnerDelegates, {
                ItemPersonID: ownerDelegate.ItemPersonID
            });
        }

        // Pool for changes if campaign's state is In Progress
        if ($scope.boxModel.ProgressState && $scope.boxModel.ProgressState.Value === 'InProgress') {
            var campaignPromise;
            var intervalPromise = $interval(function () {
                if (!$scope.boxModel._isSurvey) {
                    campaignPromise = oddCampaignService.getCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID);
                } else {
                    campaignPromise = oddCampaignService.getSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID);
                }
                campaignPromise
                 .then(function (campaign) {
                     if (campaign.ProgressState && campaign.ProgressState.Value !== 'InProgress') {
                         $interval.cancel(intervalPromise);
                         $state.reload();
                     }
                 });
            }, 500);

            $scope.$on('$destroy', function () {
                if (intervalPromise) {
                    $interval.cancel(intervalPromise);
                }
            });
        }

        // Create Or Update
        $scope.createOrUpdate = function () {
            if ($scope.form.$invalid) {
                $scope.ctrlCtxt.showSubmitError = true;

                $scope.ctrlCtxt.isFormInvalidMsgShow = true;
                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            // Fix dates timezone
            if ($scope.boxModel.StartDate) {
                $scope.boxModel.StartDate = moment($scope.boxModel.StartDate);
            }
            if ($scope.boxModel.DeadLine) {
                $scope.boxModel.DeadLine = moment($scope.boxModel.DeadLine);
            }

            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isLoading = true;

            // Create Campaign
            if (!$scope.boxModel.ODDCampaignID) {

                if ($scope.boxModel._isSurvey) {
                    return oddCampaignService
                     .createSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel)
                     .then(function (createdCampaign) {
                         $scope.form.$setPristine();
                         $state.go('odd.surveyCampaignEdit', {
                             ODDCampaignID: createdCampaign.ODDCampaignID
                         });
                     })
                     .finally(function () {
                         $scope.ctrlCtxt.isLoading = false;
                     });
                } else {
                    return oddCampaignService
                     .createCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel)
                     .then(function (createdCampaign) {
                         $scope.form.$setPristine();
                         $state.go('odd.externalPartyEdit.campaign', {
                             ODDCampaignID: createdCampaign.ODDCampaignID
                         });
                     })
                     .finally(function () {
                         $scope.ctrlCtxt.isLoading = false;
                     });
                }
            }

            var updateCampaignPromise;
            if (!$scope.boxModel._isSurvey) {
                updateCampaignPromise = oddCampaignService.updateCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel)
            } else {
                updateCampaignPromise = oddCampaignService.updateSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel)
            }
            return updateCampaignPromise
             .then(function (updCampaign) {
                 $scope.updateModel(updCampaign);
                 notificationService.notify('Your changes have been saved');
                 $scope.form.$setPristine();
             })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Is Publish Campaign Action Enabled ?
        $scope.isPublishCampaignActionEnabled = function () {
            if ($scope.boxModel._stateLoading) return false;
            if (_.get($scope, 'boxModel.ProgressStatus.Value') !== 'Draft'
                && _.get($scope, 'boxModel.ProgressStatus.Value') !== 'InPreFill') return false;
            if ($scope.form.$invalid) return false;
            if ($scope.form.$dirty) return false;
            if ($scope.boxModel.HasResponses) return false;
            if ($scope.boxModel._isSurvey) return false;
            return $scope.boxModel.ODDCampaignID;
        };

        // Add Reviewer
        $scope.addReviewer = function (reviewer) {
            $scope.boxModel.ODDReviewers = $scope.boxModel.ODDReviewers || [];
            $scope.boxModel.ODDReviewers.push(reviewer);
            $scope.form.$setDirty();
        };

        // Remove Reviewer
        $scope.removeReviewer = function (index) {
            $scope.boxModel.ODDReviewers.splice(index, 1);
            $scope.form.$setDirty();
        };

        // Show AddPreFiller Action?
        $scope.showAddPreFillerAction = function () {
            if (!$scope.boxModel._isEditable) return false;

            return _.size($scope.boxModel.ODDPreFillers) === 0;
        };

        // Add PreFiller
        $scope.addPreFiller = function (preFiller) {
            $scope.boxModel.ODDPreFillers = $scope.boxModel.ODDPreFillers || [];
            $scope.boxModel.ODDPreFillers.push(preFiller);
            $scope.form.$setDirty();
        };

        // Remove PreFiller
        $scope.removePreFiller = function (preFiller) {
            $scope.boxModel.ODDPreFillers = _.reject($scope.boxModel.ODDPreFillers, { ItemPersonID: preFiller.ItemPersonID });
            $scope.form.$setDirty();
        };

        // Publish Campaign
        $scope.publishCampaign = function () {

            var publishedCampaignAction;
            if (!_.isArray($scope.boxModel.ODDCampaignQuestionnaires) || $scope.boxModel.ODDCampaignQuestionnaires.length === 0) {
                $scope.ctrlCtxt.isShowMissingQuestionnaire = true;
                return;
            }

            $scope.ctrlCtxt.isLoading = true;

            if (!$scope.boxModel._isSurvey) {
                publishedCampaignAction = oddCampaignService
                 .publishCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel.ODDCampaignID)

            } else {
                publishedCampaignAction = oddCampaignService
                 .publishSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID)
            }
            publishedCampaignAction.then(function () {
                $state.reload()
            })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Is PreFill Campaign Action Enabled ?
        $scope.isPrefillCampaignActionEnabled = function () {
            if ($scope.boxModel._isSurvey) return false;
            if ($scope.boxModel._stateLoading || _.get($scope, 'boxModel.ProgressStatus.Value') !== 'Draft') return false;
            if ($scope.form.$invalid) return false;
            if ($scope.form.$dirty) return false;
            if ($scope.boxModel.HasResponses) return false;

            return $scope.boxModel.ODDCampaignID;
        };

        // PreFill Campaign
        $scope.preFillCampaign = function () {

            var publishedCampaignAction;
            if (!_.isArray($scope.boxModel.ODDCampaignQuestionnaires) || $scope.boxModel.ODDCampaignQuestionnaires.length === 0) {
                $scope.ctrlCtxt.isShowMissingQuestionnaire = true;
                return;
            }

            $scope.ctrlCtxt.isLoading = true;

            oddCampaignService
                .preFillCampaign($scope.boxModel.ODDBusinessUnitID,
                                 $scope.boxModel.ODDExternalPartyID,
                                 $scope.boxModel.ODDCampaignID)
                .then(function () {
                    $state.reload()
                 })
                 .finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
        };

        // Is Preview Campaign Action Enabled ?
        $scope.isPreviewCampaignActionEnabled = function () {
            if ($scope.boxModel._stateLoading) return false;
            if (_.get($scope, 'boxModel.ProgressStatus.Value') !== 'Draft') return false;
            if ($scope.form.$invalid) return false;
            if ($scope.form.$dirty) return false;
            if ($scope.boxModel.HasResponses) return false;
            if ($scope.boxModel._isSurvey) return false;
            return $scope.boxModel.ODDCampaignID;
        };

        // Preview Campaign
        $scope.previewCampaign = function () {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService
             .previewCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel.ODDCampaignID)
             .then(function () {
                 $state.reload()
             })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Unpublish Campaign
        $scope.unpublishCampaign = function () {
            $scope.ctrlCtxt.isLoading = true;
            var unpublishedCampaignAction;
        
            if (!$scope.boxModel._isSurvey) {
                unpublishedCampaignAction = oddCampaignService
                 .unpublishCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel.ODDCampaignID)

            } else {
                unpublishedCampaignAction = oddCampaignService
                 .unpublishSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID)
            }
            unpublishedCampaignAction.then(function () {
                $state.reload()
            })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Cancel Preview of Campaign
        $scope.cancelPreviewCampaign = function () {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService
             .cancelPreviewCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel.ODDCampaignID)
             .then(function () {
                 $state.reload()
             })
             .finally(function () {
                 $scope.ctrlCtxt.isLoading = false;
             });
        };

        // Delete Campaign
        $scope.deleteCampaign = function () {
            $scope.ctrlCtxt.isLoading = true;
            //Switch delete depending if its a campaign survey.

            if (!$scope.boxModel._isSurvey) {
                oddCampaignService
                 .deleteCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDExternalPartyID, $scope.boxModel.ODDCampaignID)
                 .then(function () {
                     notificationService.notify('Campaign has been deleted');
                     $state.go('odd.externalPartyEdit', {
                         ODDExternalPartyID: $scope.boxModel.ODDExternalPartyID
                     }, {
                         reload: true
                     });

                 })
                 .finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
            } else {
                oddCampaignService
                 .deleteSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID)
                 .then(function () {
                     notificationService.notify('Campaign has been deleted');
                     $state.go('odd.surveyCampaigns');
                 })
                 .finally(function () {
                     $scope.ctrlCtxt.isLoading = false;
                 });
            }
        };

        // Duplicate Campaign
        $scope.duplicateCampaign = function () {

            modalService.displayFormModal(
                // Title
                'Please provide a title for the duplicated campaign',

                // Content Config
                [{ key: 'title', label: 'Title', type: modalService.types.TEXT, required: true }],

                // Success Callback
                function (values) {
                    return oddCampaignService
                     .duplicateSurveyCampaign($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDCampaignID, values.title, $scope.boxModel)
                     .then(function (createdCampaign) {
                         $scope.form.$setPristine();
                         $state.go('odd.surveyCampaignEdit', {
                             ODDCampaignID: createdCampaign.ODDCampaignID
                         });
                     });
                }
            );
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go($state.$current.parent.name, {
                reload: true
            });
        };
    }

})();